import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import store from "./stores";
import App from "./App";
import { ConfigProvider } from "antd";
import { BrowserRouter } from "react-router-dom";
import { initI18n } from "./i18n";
import { pollExportQueryFileList } from "./stores/system/system.store";
import zhCN from "antd/lib/locale/zh_CN";
import enUS from "antd/lib/locale/en_US";
import viVN from "antd/lib/locale/vi_VN";
import esES from "antd/lib/locale/es_ES";

// 语言到 antd locale 的映射
const antdLocales: Record<string, any> = {
  "zh-CN": zhCN,
  "en-US": enUS,
  "vi-VN": viVN,
  "es-ES": esES
};

// 获取当前语言对应的 antd locale
const getAntdLocale = (lang: string) => {
  return antdLocales[lang] || enUS; // 默认 zhCN
  // return enUS; // 默认 zhCN
};

const lang = localStorage.getItem("gs_lang") || "zh-CN";
// const lang = "en-US";

const renderApp = () => {
  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);

    // 定义一个包装组件来动态更新 locale
    const RootApp: React.FC = () => {
      const [locale, setLocale] = useState(getAntdLocale(lang));

      // 监听 i18n 语言变化
      useEffect(() => {
        const handleLanguageChange = (newLang: string) => {
          setLocale(getAntdLocale(newLang));
          console.log("Language changed to:", newLang);
        };

        // 假设 initI18n 返回的 i18n 实例已正确初始化
        const i18n = require("./i18n").default; // 确保 i18n 已导出
        i18n.on("languageChanged", handleLanguageChange);

        return () => {
          i18n.off("languageChanged", handleLanguageChange);
        };
      }, []);

      return (
        <ConfigProvider locale={locale}>
          <Provider store={store}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Provider>
        </ConfigProvider>
      );
    };

    root.render(<RootApp />);
  }
};

// 初始化 i18n 并在完成后渲染应用
initI18n(lang)
  .then(() => {
    console.log("i18n initialized with language:", lang);
    if(!window.location.href.includes('account/login')) {
    store.dispatch(pollExportQueryFileList());
    }
    renderApp();
  })
  .catch(error => {
    console.error("Error initializing i18n:", error);
    store.dispatch(pollExportQueryFileList());
    renderApp(); // 即使失败也渲染应用
  });

reportWebVitals();
